import * as RadixAccordion from '@radix-ui/react-accordion';
import { Flex } from 'front-commons/ds';
import ValuesSummary from 'containers/Summaries/ValuesSummary';
import { getValuesSummary } from './helpers';
import { SummaryAccordionProps } from '../../interfaces';
import { SummaryContent, SummaryRoot, Trigger } from './styles';
import { Typography, Icon } from 'hype-ds';

export default function SummaryAccordion({ summaryHandlers }: SummaryAccordionProps) {
	return (
		<Flex direction="column" gap="0px">
			<SummaryRoot type="multiple">
				<RadixAccordion.Item value="summary">
					<RadixAccordion.Header asChild>
						<Trigger asChild>
							<Flex alignItems="center" cursor="pointer" gap="0">
								<Flex as={Typography.Label.S} color="--text-link" raw={{ cursor: 'inherit' }}>
									Resumo
								</Flex>

								<Icon name="expand_more" size="16px" color="--text-link" />
							</Flex>
						</Trigger>
					</RadixAccordion.Header>
					<SummaryContent>
						<ValuesSummary
							{...getValuesSummary(summaryHandlers.get())}
							hideValue={{ total: true, totalLiquid: true }}
						/>
					</SummaryContent>
				</RadixAccordion.Item>
			</SummaryRoot>

			<Flex
				justifyContent="space-between"
				border="1px solid"
				borderColor="--border-primary"
				borderWidth="1px 0 0"
				padding="8px 0 0"
				margin="8px 0 0"
			>
				<Typography.Paragraph.M>Total</Typography.Paragraph.M>
				<Typography.Label.L>{getValuesSummary(summaryHandlers.get()).liquid?.toCurrency()}</Typography.Label.L>
			</Flex>
		</Flex>
	);
}
